import React from "react";
import styled from "styled-components";

const PopupContainer = styled.div`
  position: absolute;
  z-index: 10;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  padding: 12px;
  min-width: 220px;
  pointer-events: auto;
`;

const RunPopup = ({
  selectedResortId,
  setSelectedRunId,
  marker,
  setResortRuns,
}) => {
  return null;
  return (
    <PopupContainer style={{ left: marker.x + 16, top: marker.y - 20 }}>
      <strong>{marker.run.name}</strong>
      <br />
      Completed: {marker.run.completions || 0} times
      <br />
      <button
        style={{
          display: "block",
          marginTop: 8,
          padding: "4px 8px",
          background: "#dc3545",
          color: "white",
          border: "none",
          borderRadius: 4,
          cursor: "pointer",
          width: "100%",
          outline: "none",
        }}
        onClick={async () => {
          await handleDeleteRun(selectedResortId, marker.run.id, setResortRuns);
          setSelectedRunId(null);
        }}
      >
        Delete Run
      </button>
      <button
        style={{
          display: "block",
          marginTop: 8,
          padding: "4px 8px",
          background: "#eee",
          color: "#333",
          border: "none",
          borderRadius: 4,
          cursor: "pointer",
          width: "100%",
          outline: "none",
        }}
        onClick={() => setSelectedRunId(null)}
      >
        Close
      </button>
    </PopupContainer>
  );
};

const handleDeleteRun = async (selectedResortId, runId, setResortRuns) => {
  try {
    console.log("Attempting to delete run:", runId);

    const response = await fetch(
      `/api/resort/${selectedResortId}/runs/${runId}`,
      {
        method: "DELETE",
      }
    );

    console.log("Delete response status:", response.status);
    if (response.ok) {
      const updatedRuns = await response.json();
      setResortRuns(updatedRuns);
      return true;
    } else {
      console.error("Delete failed with status:", response.status);
      const errorData = await response.json();
      console.error("Error details:", errorData);
    }
  } catch (err) {
    console.error("Failed to delete run:", err);
  }
};

export default RunPopup;
